import { render, staticRenderFns } from "./labelgroups-set.vue?vue&type=template&id=30df361e&scoped=true"
import script from "./labelgroups-set.vue?vue&type=script&lang=js"
export * from "./labelgroups-set.vue?vue&type=script&lang=js"
import style0 from "./labelgroups-set.vue?vue&type=style&index=0&id=30df361e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30df361e",
  null
  
)

export default component.exports